import { render, staticRenderFns } from "./addQuizLms.vue?vue&type=template&id=cdc17ad2&scoped=true&"
import script from "./addQuizLms.vue?vue&type=script&lang=js&"
export * from "./addQuizLms.vue?vue&type=script&lang=js&"
import style0 from "./addQuizLms.vue?vue&type=style&index=0&id=cdc17ad2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc17ad2",
  null
  
)

export default component.exports